import React, { Component } from "react";
import {
  Container,
  Grid,
  Typography,
  TextField,
  Button,
  Card,
  CardContent,
  CardActions,
  Snackbar,
  Alert,
  Box,
  Avatar,
  CircularProgress,
  Paper,
  InputAdornment,
  Chip
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import PeopleIcon from '@mui/icons-material/People';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { findPeople, follow } from "./apiUser";
import { Link } from "react-router-dom";
import { isAuthenticated } from "../auth";

class FindPeople extends Component {
    constructor(props) {
        super(props);
        this.state = {
            users: [],
            error: "",
            open: false,
            searchText: '',
            loading: false,
            searched: false
        };
        this.clickSearch = this.clickSearch.bind(this);
        this.searchTimer = null;
    }


    componentDidMount() {
        // ReactGA.initialize('UA-331790-15');
        // ReactGA.pageview('/findpeople');

        // this.setState({ userId: isAuthenticated().userid, token: isAuthenticated().token})
        // findPeople(this.userId, this.state.searchText, this.token).then(data => {
        //     if (data.error) {
        //         console.log(data.error);
        //     } else {
        //         this.setState({ users: data });
        //     }
        // });
    }

    clickSearch(){
        if (!this.state.searchText.trim()) {
            this.setState({ users: [], searched: false });
            return;
        }

        this.setState({ loading: true });
        findPeople(isAuthenticated() && isAuthenticated().userId, this.state.searchText, isAuthenticated() && isAuthenticated().token).then(data => {
            if (data.error) {
                console.log(data.error);
                this.setState({ loading: false, error: data.error });
            } else {
                console.log(data)
                this.setState({ users: data, loading: false, searched: true });
            }
        });
    };

    handleChange = name => event => {
        const input = event.target;
        const value = event.target.type === 'checkbox' ? input.checked : input.value;

        this.setState({ error: "", [name]: value });

        // Dynamic search with debouncing (wait 500ms after user stops typing)
        if (name === 'searchText') {
            clearTimeout(this.searchTimer);
            this.searchTimer = setTimeout(() => {
                this.clickSearch();
            }, 500);
        }
    };

    clickFollow = (user, i) => {

        follow(isAuthenticated() && isAuthenticated().userId, isAuthenticated() && isAuthenticated().token, user._id).then(data => {
            if (data.error) {
                this.setState({ error: data.error });
            } else {
                let toFollow = this.state.users;
                toFollow.splice(i, 1);
                this.setState({
                    users: toFollow,
                    open: true,
                    followMessage: `Following ${user.name}`
                });
            }
        });
    };

    renderUsers = users => (
        <Grid container spacing={3}>
            {users.map((user, i) => (
                <Grid item xs={12} sm={6} md={4} key={i}>
                    <Card
                        elevation={2}
                        sx={{
                            height: '100%',
                            display: 'flex',
                            flexDirection: 'column',
                            transition: 'all 0.3s ease',
                            '&:hover': {
                                transform: 'translateY(-4px)',
                                boxShadow: '0 8px 16px rgba(0, 62, 126, 0.15)',
                            }
                        }}
                    >
                        <CardContent sx={{ flexGrow: 1, textAlign: 'center', pt: 3 }}>
                            <Avatar
                                src={`${process.env.REACT_APP_API_URL}/user/photo/${user._id}`}
                                alt={user.name}
                                sx={{
                                    width: 80,
                                    height: 80,
                                    margin: '0 auto 16px',
                                    border: '3px solid #003E7E',
                                    fontSize: '2rem',
                                    backgroundColor: '#003E7E',
                                    color: 'white'
                                }}
                            >
                                {user.name ? user.name[0].toUpperCase() : '?'}
                            </Avatar>
                            <Typography variant="h6" sx={{ fontWeight: 600, mb: 0.5, color: '#003E7E' }}>
                                {user.name} {user.lastName}
                            </Typography>
                            {user.companyName && (
                                <Chip
                                    label={user.companyName}
                                    size="small"
                                    sx={{
                                        mt: 1,
                                        backgroundColor: 'rgba(0, 62, 126, 0.1)',
                                        color: '#003E7E',
                                        fontWeight: 500
                                    }}
                                />
                            )}
                        </CardContent>
                        <CardActions sx={{ justifyContent: 'space-between', p: 2, pt: 0 }}>
                            <Button
                                component={Link}
                                to={`/user/${user._id}`}
                                variant="outlined"
                                size="small"
                                startIcon={<VisibilityIcon />}
                                sx={{
                                    borderColor: '#003E7E',
                                    color: '#003E7E',
                                    '&:hover': {
                                        borderColor: '#003E7E',
                                        backgroundColor: 'rgba(0, 62, 126, 0.05)',
                                    }
                                }}
                            >
                                View
                            </Button>
                            <Button
                                onClick={() => this.clickFollow(user, i)}
                                variant="contained"
                                size="small"
                                startIcon={<PersonAddIcon />}
                                sx={{
                                    backgroundColor: '#FF6600',
                                    '&:hover': {
                                        backgroundColor: '#e55a00',
                                    }
                                }}
                            >
                                Follow
                            </Button>
                        </CardActions>
                    </Card>
                </Grid>
            ))}
        </Grid>
    );

    render() {
        const { users, open, followMessage, searchText, loading, searched } = this.state;
        return (
            <>
                {/* Hero Section */}
                <Box sx={{ backgroundColor: '#003E7E', color: 'white', py: 5, mb: 4 }}>
                    <Container maxWidth="lg">
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
                            <PeopleIcon sx={{ fontSize: 56 }} />
                            <Box>
                                <Typography variant="h3" component="h1" sx={{ fontWeight: 600, mb: 0.5 }}>
                                    Find People
                                </Typography>
                                <Typography variant="body1" sx={{ opacity: 0.9 }}>
                                    Connect with other members of the SDSIC community
                                </Typography>
                            </Box>
                        </Box>

                        {/* Search Box in Hero */}
                        <Paper
                            elevation={3}
                            sx={{
                                p: 1,
                                backgroundColor: 'white',
                                borderRadius: 2,
                                maxWidth: 700
                            }}
                        >
                            <TextField
                                fullWidth
                                placeholder="Search by name..."
                                name="searchText"
                                value={searchText}
                                onChange={this.handleChange("searchText")}
                                variant="outlined"
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <SearchIcon sx={{ color: '#003E7E', fontSize: 28 }} />
                                        </InputAdornment>
                                    ),
                                    endAdornment: loading && (
                                        <InputAdornment position="end">
                                            <CircularProgress size={24} sx={{ color: '#003E7E' }} />
                                        </InputAdornment>
                                    ),
                                    sx: {
                                        '& fieldset': { border: 'none' },
                                        fontSize: '1.1rem'
                                    }
                                }}
                            />
                        </Paper>
                        <Typography variant="caption" sx={{ display: 'block', mt: 1, opacity: 0.8, ml: 1 }}>
                            First Names Only. Search updates automatically as you type
                        </Typography>
                    </Container>
                </Box>

                <Container maxWidth="lg" sx={{ mb: 6 }}>
                    <Snackbar
                        open={open}
                        autoHideDuration={6000}
                        onClose={() => this.setState({ open: false })}
                        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                    >
                        <Alert onClose={() => this.setState({ open: false })} severity="success">
                            {followMessage}
                        </Alert>
                    </Snackbar>

                    {/* Results Count */}
                    {searched && !loading && (
                        <Box sx={{ mb: 3 }}>
                            <Typography variant="h6" sx={{ color: '#003E7E', fontWeight: 600 }}>
                                {users.length === 0 ? 'No results found' : `Found ${users.length} ${users.length === 1 ? 'person' : 'people'}`}
                            </Typography>
                        </Box>
                    )}

                    {/* Loading State */}
                    {loading && (
                        <Box sx={{ textAlign: 'center', py: 8 }}>
                            <CircularProgress size={60} sx={{ color: '#003E7E', mb: 2 }} />
                            <Typography variant="h6" color="text.secondary">
                                Searching...
                            </Typography>
                        </Box>
                    )}

                    {/* Empty State */}
                    {!loading && searched && users.length === 0 && (
                        <Paper
                            elevation={0}
                            sx={{
                                p: 6,
                                textAlign: 'center',
                                backgroundColor: 'rgba(0, 62, 126, 0.02)',
                                borderRadius: 3
                            }}
                        >
                            <PeopleIcon sx={{ fontSize: 80, color: '#003E7E', opacity: 0.3, mb: 2 }} />
                            <Typography variant="h5" sx={{ mb: 1, color: '#003E7E', fontWeight: 600 }}>
                                No results found
                            </Typography>
                            <Typography variant="body1" color="text.secondary">
                                Try searching with a different name
                            </Typography>
                        </Paper>
                    )}

                    {/* Initial State */}
                    {!loading && !searched && (
                        <Paper
                            elevation={0}
                            sx={{
                                p: 6,
                                textAlign: 'center',
                                backgroundColor: 'rgba(0, 62, 126, 0.02)',
                                borderRadius: 3
                            }}
                        >
                            <SearchIcon sx={{ fontSize: 80, color: '#003E7E', opacity: 0.3, mb: 2 }} />
                            <Typography variant="h5" sx={{ mb: 1, color: '#003E7E', fontWeight: 600 }}>
                                Start searching
                            </Typography>
                            <Typography variant="body1" color="text.secondary">
                                Enter a name above to find people in the community
                            </Typography>
                        </Paper>
                    )}

                    {/* Results */}
                    {!loading && users.length > 0 && this.renderUsers(users)}
                </Container>
            </>
        );
    }
}

export default FindPeople;